import { fromPromise } from 'xstate';

import { formatErrorForLogging } from '@eluve/eluve-errors';
import { AppointmentFileTypesLookup } from '@eluve/graphql-types';
import { Logger } from '@eluve/logger';
import { isAudioFileChunkFile } from '@eluve/utils';

import { AppointmentFileIdbRow } from '../../files-db';
import { AppointmentFilesTableDependency, FileDriftReport } from '../types';

export const reconcileDrift = fromPromise<
  void,
  {
    logger: Logger;
    driftReport: FileDriftReport;
    appointmentFilesTable: AppointmentFilesTableDependency;
  }
>(async ({ input }) => {
  const { appointmentFilesTable, driftReport, logger } = input;
  // throw new Error('reconcileDrift not implemented');
  if (driftReport.type === 'NoDriftDetected') {
    logger.warn('No drift detected. Nothing to reconcile');
    return;
  }

  const { missingInIdb, missingInOpfs } = driftReport;

  if (missingInOpfs.length) {
    try {
      await appointmentFilesTable.bulkDelete(missingInOpfs);
    } catch (e) {
      logger.error(
        'Failed to remove file references from idb that are missing in OPFS',
        {
          error: e,
        },
      );
    }
  }

  if (missingInIdb.length) {
    logger.warn('Found files in OPFS that are missing in db', {
      count: missingInIdb.length,
    });

    try {
      const bulkAddData: AppointmentFileIdbRow[] = missingInIdb.map((x) => ({
        id: x.id,
        appointmentId: x.appointmentId,
        lastUploadAttemptedAt: new Date(0).toISOString(),
        attemptCount: 0,
        uploadType: isAudioFileChunkFile(x.id)
          ? AppointmentFileTypesLookup.CHUNKED_AUDIO
          : AppointmentFileTypesLookup.USER_BACKUP_AUDIO,
        // Assume that these are true since this is a lost file and we
        // don't have any other info
        wasDegraded: true,
        shouldBeTranscribed: true,
      }));
      await appointmentFilesTable.bulkAdd(bulkAddData);
    } catch (e) {
      logger.warn('Failed to add missing files to idb', {
        error: formatErrorForLogging(e),
      });
    }
  }
});
